import { GeneralSettings, Keys, Logger, LogManager } from "@mcleod/core";
import { GlobalKeyHandlerGroup } from "../../keyhandling/GlobalKeyHandlerGroup";
import { KeyHandler } from "../../keyhandling/KeyHandler";
import { TooltipDisplayer } from "./TooltipDisplayer";

export class TooltipAutomationUtil {
    private static settingsChangeListener: (newConfig: any, oldConfig: any, isAuthSet: boolean) => void;
    private static _log: Logger;

    static _addSettingsChangeListener() {
        // This method should only be called once, but just to be safe make sure we don't add duplicate listeners
        if (this.settingsChangeListener == null) {
            this.getLog().debug("Adding settings change listener for the purpose of detecting if the environment is " +
                "being used for automated testing.");
            this.settingsChangeListener = TooltipAutomationUtil.syncTooltipRemovalHotKeys;
            GeneralSettings.getSingleton().addSettingsChangeListener(this.settingsChangeListener);
        }
    }

    static syncTooltipRemovalHotKeys = () => {
        if (GeneralSettings.isRunningAutomation === true) {
            GlobalKeyHandlerGroup.add(this.removeAllTooltipsHotKey);
            GlobalKeyHandlerGroup.add(this.removeNewestTooltipHotKey);
        } else  {
            GlobalKeyHandlerGroup.remove(this.removeAllTooltipsHotKey.listener);
            GlobalKeyHandlerGroup.remove(this.removeNewestTooltipHotKey.listener);
        }
    };

    private static removeAllTooltipsHotKey: KeyHandler = {
        key: Keys.A,
        modifiers: { ctrlKey: true, shiftKey: true },
        listener: () => TooltipDisplayer.removeAll()
    };

    private static removeNewestTooltipHotKey: KeyHandler = {
        key: Keys.Y,
        modifiers: { ctrlKey: true, shiftKey: true },
        listener: () => TooltipDisplayer.removeNewestTooltip()
    };

    private static getLog(): Logger {
        if (this._log == null) {
            this._log = LogManager.getLogger("components.page.tooltips.TooltipAutomationUtil");
        }
        return this._log;
    }
}
TooltipAutomationUtil._addSettingsChangeListener();
